export const FAVORITES_STORAGE_KEY = 'podcast_favorites';

export const getFavorites = () => {
  const favorites = localStorage.getItem(FAVORITES_STORAGE_KEY);
  return favorites ? JSON.parse(favorites) : [];
};

export const saveFavorites = (favorites) => {
  localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(favorites));
}; 